<!-- prettier-ignore -->
<template>
  <v-app id="login" class="white">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-toolbar dark class="app-style">
              <v-toolbar-title>Login form</v-toolbar-title>
            </v-toolbar>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div id="g_id_signin"></div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  computed: {
    error() {
      return this.$store.state.error;
    },
    loading() {
      return this.$store.state.loading;
    }
  },
  created() {
    this.$store.commit("setError", null);
  },
  mounted() {
    // Dynamically load Google Identity Services SDK
    if (!window.google || !window.google.accounts) {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      script.onload = this.initializeGoogleSignIn;
      document.head.appendChild(script);
    } else {
      this.initializeGoogleSignIn();
    }
  },
  methods: {
    initializeGoogleSignIn() {
      const clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID;
      if (!clientId) {
        this.$notify && this.$notify({text: 'Google Client ID not set.', type: "error"});
        return;
      }
      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: this.handleGoogleCredentialResponse
      });
      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        { theme: "outline", size: "large", width: 300 }
      );
    },
    handleGoogleCredentialResponse(response) {
      // response.credential is a JWT ID token
      this.$store.commit("setLoading", true);
      this.$store.dispatch("auth/signInWithGoogle", { credential: response.credential })
        .then(() => {
          this.$router.push("/").catch(error => {
            console.info(error.message);
          });
          this.$notify && this.$notify({text: 'Login successfully.', type: "success"});
        })
        .catch(error => {
          this.$notify && this.$notify({text: 'Login failed.', type: "error"});
          console.log("Google login failed:", error);
        });
    }
  }
};
</script>

<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
